




























import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { RectangleLayer } from "@/model/document2/page/surface/design/layer/rectangleLayer";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class RectangleRadiusController extends Vue 
{
    @Prop() layer! : RectangleLayer;

    private get horizontalRadius()
    {
        return this.layer.horizontalRadius;
    }

    private set horizontalRadius(horizontalRadius)
    {
        this.changeLayerProperty("horizontalRadius", Number(horizontalRadius), false, false);
    }

    private get horizontalRadiusText()
    {
        return this.layer.horizontalRadius.toFixed() + "%";
    }

    private onHorizontalRadiusChanged()
    {
        this.changeLayerProperty("horizontalRadius", this.layer.horizontalRadius, true, false);
    }

    private get verticalRadius()
    {
        return this.layer.verticalRadius;
    }

    private set verticalRadius(verticalRadius)
    {
        this.changeLayerProperty("verticalRadius", Number(verticalRadius), false, false);
    }

    private get verticalRadiusText()
    {
        return this.layer.verticalRadius.toFixed() + "%";
    }

    private onVerticalRadiusChanged()
    {
        this.changeLayerProperty("verticalRadius", this.layer.verticalRadius, true, false);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
